export default __webpack_public_path__ + "static/media/arrow-small.1904e7e5.svg";